import { getRevieweeIdsList, getReviewerIdsList } from './reviewEvaluatorSelection';
import { getFullName } from './user';

import type { User } from '@/types/directory/User';
import type { ReviewEvaluatorSelection } from '@/types/review/ReviewAudience';

export const createUserLookup = (users: User[]) => {
    const getUser = (userId?: string) => {
        return users.find((user) => user.id === userId);
    };

    const getUserFullName = (userId?: string) => {
        const user = getUser(userId);
        return getFullName(user);
    };

    const getAllReviewees = (reviewEvaluatorSelection?: ReviewEvaluatorSelection): User[] => {
        if (!reviewEvaluatorSelection) {
            return [];
        }

        const userIds = getRevieweeIdsList(reviewEvaluatorSelection);

        return users.filter((user) => userIds.includes(user.id));
    };

    const getAllReviewers = (reviewEvaluatorSelection?: ReviewEvaluatorSelection): User[] => {
        if (!reviewEvaluatorSelection) {
            return [];
        }

        const reviewerIds = getReviewerIdsList(reviewEvaluatorSelection);
        return users.filter((user) => reviewerIds.includes(user.id));
    };

    return {
        getUser,
        getUserFullName,
        getAllReviewees,
        getAllReviewers,
    };
};
